<template>
    <div class="app-approval-button">
        <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
            <b-button v-if="showRejectButton" size="sm" class="float-right btn-outline-danger" @click="rejectAction">
              {{ rejectButtonTitle }}
            </b-button>
          </b-overlay>
          <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
            <b-button v-if="showRevisionButton" size="sm" class="float-right btn-outline-warning" @click="revisionAction">
              {{ revisionButtonTitle }}
            </b-button>
          </b-overlay>
          <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
            <b-button v-if="showApproveButton" size="sm" class="float-right btn-fill-success" @click="approveAction">
              {{ approveButtonTitle }}
            </b-button>
          </b-overlay>
    </div>
</template>
<script>
import PopupApprovalHistory from './PopupApprovalHistory.vue';

export default {
  name: 'PopupWrap',
  components: {PopupApprovalHistory},
  props: {
    copyDataMethod: {},
    isShowCopyData: {
      default: true,
      type: Boolean,
    },
    okTitle: {
      default: 'Close',
      type: String,
    },
    cancelTitle: {
      default: 'Copy Data',
      type: String,
    },
    okVariant: {
      default: 'success',
      type: String,
    },
    cancelVariant: {
      default: 'secondary',
      type: String,
    },
     isBusy: {
      default: false,
      type: Boolean,
    },
    approveMethod: {},
    showApproveButton: {
      type: Boolean,
      default: true
    },
    approveButtonTitle: {
      default: 'Approve Request',
      type: String,
    }, 
    approveButtonVariant: {
      default: 'success',
      type: String,
    },
    rejectMethod:{},
    showRejectButton: {
      type: Boolean,
      default: true
    },
    rejectButtonTitle: {
      default: 'Reject Request',
      type: String,
    },
     rejectButtonVariant: {
      default: 'warning',
      type: String,
    },
    revisionMethod:{},
    showRevisionButton: {
      type: Boolean,
      default: true
    },
    revisionButtonTitle: {
      default: 'Revise Request',
      type: String,
    },
     revisionButtonVariant: {
      default: 'default',
      type: String,
    },
    showApprovalHistoryButton: {
      type: Boolean,
      default: true
    },
    approvalInstanceId: {
      value: [String,Number],
    }
  },
  data() {
    return {
      show : true,
      isShowApprovalHistory: false,
    }
  },
  mounted() {
    this.activate();
    this.$on('hook:destroyed', () => {
      this.deactivate();
    });
  },
  computed : {
    showCopyData() {
      if (this.isShowCopyData != null && this.isShowCopyData != undefined) return this.isShowCopyData;
      return true;
    }
  },
  methods: {
    async approveAction(modalEvent, model) {
      this.$emit("approveMethod", modalEvent, this.$emit);
    },
    async rejectAction(modalEvent, model) {
      this.$emit("rejectMethod", modalEvent);
    },
    revisionAction(modalEvent, model) {
      this.$emit("revisionMethod", modalEvent);
    },
    activate() {
      this.previousActiveElement = document.activeElement;
      this.inert();
    },
    showApprovalHistory() {
      this.isShowApprovalHistory = true;
    },
    resetMethod() {
      this.isShowApprovalHistory = false;
    },
    async deactivate() {
      await this.inert(false);
    },
    async inert(status = true) {
      await this.$nextTick();
      [...this.$root.$el.children].forEach((child) => {
        if (child === this.$el || child.contains(this.$el)) return;
        child.inert = status;
      });
    },
  },
};
</script>